import React, { ReactNode, useContext } from 'react'

import styles from './index.module.css'
import { CardContext } from '..'

export interface IHeaderProps {
  children: ReactNode
}

export const Header = (props: IHeaderProps) => {
  const { children } = props

  const { variant, featured, featuredText } = useContext(CardContext)

  return (
    <header
      className={styles.container}
      data-variant={variant}
      data-featured={featured}
      data-featured-text={!!featuredText}
      data-testid="card-header"
    >
      {children}
    </header>
  )
}

Header.displayName = 'Card.Header'
